import { render, staticRenderFns } from "./RequisitionEditView.vue?vue&type=template&id=68fa6cb8"
import script from "./RequisitionEditView.vue?vue&type=script&lang=js"
export * from "./RequisitionEditView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports